(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hw-photos"] && !Shopify.designMode) return;
  try {
    
(()=> {
const instances=new Map();
function init(root){
if(instances.has(root))return;
const viewport=root.querySelector('.hw-photo-window'),track=root.querySelector('.hw-photo-track'),button=root.querySelector('[data-hw-pause]');
const originals=[...track.children],motion=matchMedia('(prefers-reduced-motion: reduce)');
let stopped=false,hover=false,focused=false,visible=true,frame=0,last=0,position=0;
const editor=Boolean(window.Shopify&&Shopify.designMode);
const canMove=()=>root.dataset.autoplay==='true'&&!editor&&!motion.matches&&!stopped&&!hover&&!focused&&visible&&!document.hidden;
let clones=[];
if(originals.length>1&&!editor){clones=originals.map(el=>{const copy=el.cloneNode(true);copy.setAttribute('aria-hidden','true');copy.inert=true;[copy,...copy.querySelectorAll('*')].forEach(n=>{[...n.attributes].forEach(a=>{if(a.name.startsWith('data-shopify')||a.name==='id')n.removeAttribute(a.name)})});track.append(copy);return copy})}
function tick(time){if(!root.isConnected)return;
if(last&&canMove()&&clones.length){const distance=clones[0].offsetLeft-originals[0].offsetLeft;position+=Math.min(time-last,50)*.025;if(distance>0&&position>=distance)position-=distance;viewport.scrollLeft=position}
if(!canMove())position=viewport.scrollLeft;last=time;frame=requestAnimationFrame(tick)}
const onEnter=()=>{hover=true},onLeave=()=>{hover=false},onFocus=()=>{focused=true},onBlur=e=>{if(!root.contains(e.relatedTarget))focused=false};
const stop=()=>{stopped=true;button.textContent=button.dataset.playLabel};
const toggle=()=>{stopped=!stopped;button.textContent=stopped?button.dataset.playLabel:button.dataset.pauseLabel};
root.addEventListener('mouseenter',onEnter);root.addEventListener('mouseleave',onLeave);root.addEventListener('focusin',onFocus);root.addEventListener('focusout',onBlur);
viewport.addEventListener('pointerdown',stop);button.addEventListener('click',toggle);
const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting});observer.observe(root);
frame=requestAnimationFrame(tick);
instances.set(root,()=>{cancelAnimationFrame(frame);observer.disconnect();clones.forEach(el=>el.remove());root.removeEventListener('mouseenter',onEnter);root.removeEventListener('mouseleave',onLeave);root.removeEventListener('focusin',onFocus);root.removeEventListener('focusout',onBlur);viewport.removeEventListener('pointerdown',stop);button.removeEventListener('click',toggle);instances.delete(root)});
}
function scan(){document.querySelectorAll('[data-hw-carousel]').forEach(init)}
scan();document.addEventListener('shopify:section:load',scan);
document.addEventListener('shopify:section:unload',event=>{instances.forEach((destroy,root)=>{if(event.target.contains(root))destroy()})});
document.addEventListener('shopify:block:select',event=>{if(event.target.closest('[data-hw-carousel]'))event.target.scrollIntoView({behavior:'auto',block:'nearest',inline:'center'})});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-photos"] && !Shopify.designMode) return;
  try {
    
(()=> {
const instances=new Map();
function init(root){
if(instances.has(root))return;
const viewport=root.querySelector('.kr-photo-window'),track=root.querySelector('.kr-photo-track'),button=root.querySelector('[data-kr-pause]');
const originals=[...track.children],motion=matchMedia('(prefers-reduced-motion: reduce)');
let stopped=false,hover=false,focused=false,visible=true,frame=0,last=0,position=0;
const editor=Boolean(window.Shopify&&Shopify.designMode);
const canMove=()=>root.dataset.autoplay==='true'&&!editor&&!motion.matches&&!stopped&&!hover&&!focused&&visible&&!document.hidden;
let clones=[];
if(originals.length>1&&!editor){clones=originals.map(el=>{const copy=el.cloneNode(true);copy.setAttribute('aria-hidden','true');copy.inert=true;[copy,...copy.querySelectorAll('*')].forEach(n=>{[...n.attributes].forEach(a=>{if(a.name.startsWith('data-shopify')||a.name==='id')n.removeAttribute(a.name)})});track.append(copy);return copy})}
function tick(time){if(!root.isConnected)return;
if(last&&canMove()&&clones.length){const distance=clones[0].offsetLeft-originals[0].offsetLeft;position+=Math.min(time-last,50)*.025;if(distance>0&&position>=distance)position-=distance;viewport.scrollLeft=position}
if(!canMove())position=viewport.scrollLeft;last=time;frame=requestAnimationFrame(tick)}
const onEnter=()=>{hover=true},onLeave=()=>{hover=false},onFocus=()=>{focused=true},onBlur=e=>{if(!root.contains(e.relatedTarget))focused=false};
const stop=()=>{stopped=true;button.textContent=button.dataset.playLabel};
const toggle=()=>{stopped=!stopped;button.textContent=stopped?button.dataset.playLabel:button.dataset.pauseLabel};
root.addEventListener('mouseenter',onEnter);root.addEventListener('mouseleave',onLeave);root.addEventListener('focusin',onFocus);root.addEventListener('focusout',onBlur);
viewport.addEventListener('pointerdown',stop);button.addEventListener('click',toggle);
const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting});observer.observe(root);
frame=requestAnimationFrame(tick);
instances.set(root,()=>{cancelAnimationFrame(frame);observer.disconnect();clones.forEach(el=>el.remove());root.removeEventListener('mouseenter',onEnter);root.removeEventListener('mouseleave',onLeave);root.removeEventListener('focusin',onFocus);root.removeEventListener('focusout',onBlur);viewport.removeEventListener('pointerdown',stop);button.removeEventListener('click',toggle);instances.delete(root)});
}
function scan(){document.querySelectorAll('[data-kr-carousel]').forEach(init)}
scan();document.addEventListener('shopify:section:load',scan);
document.addEventListener('shopify:section:unload',event=>{instances.forEach((destroy,root)=>{if(event.target.contains(root))destroy()})});
document.addEventListener('shopify:block:select',event=>{if(event.target.closest('[data-kr-carousel]'))event.target.scrollIntoView({behavior:'auto',block:'nearest',inline:'center'})});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
function prepareFamilyProducts(){
document.querySelectorAll('[data-family-product]').forEach(root=>{
if(root.dataset.prepared)return;root.dataset.prepared='true';
const select=root.querySelector('[data-variant-select]');if(!select)return;
select.addEventListener('change',()=>{
const option=select.selectedOptions[0],button=root.querySelector('[data-add-button]');
root.querySelector('[data-product-price]').textContent=option.dataset.price;
button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.soldLabel:button.dataset.addLabel;
const image=root.querySelector('.product-media img');if(image&&option.dataset.image){image.removeAttribute('srcset');image.src=option.dataset.image;image.alt=option.dataset.imageAlt||'';}
const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
});
});
}
prepareFamilyProducts();document.addEventListener('shopify:section:load',prepareFamilyProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masterclass-draft"] && !Shopify.designMode) return;
  try {
    
function initialiseMasterclassDrafts(){
document.querySelectorAll('[data-masterclass-draft]').forEach(root=>{
if(root.dataset.ready)return;
root.dataset.ready='true';
const guests=root.querySelector('[data-mc-guests]'),total=root.querySelector('[data-mc-total]');
guests.addEventListener('change',()=>{const count=Math.min(15,Math.max(10,Number(guests.value)||10));total.textContent=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP',maximumFractionDigits:0}).format(550+(count-10)*55);});
});
}
initialiseMasterclassDrafts();
document.addEventListener('shopify:section:load',initialiseMasterclassDrafts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masterclass-product"]) return;
  try {
    
function initialiseClassProducts(){
document.querySelectorAll('[data-class-product]').forEach(root=>{
if(root.dataset.ready)return;
root.dataset.ready='true';
const select=root.querySelector('[data-class-date]'),quantity=root.querySelector('[data-class-quantity]'),button=root.querySelector('[data-class-add]');
select.addEventListener('change',()=>{
const option=select.selectedOptions[0];
root.querySelector('[data-class-price]').textContent=option.dataset.price;
quantity.max=Math.max(1,Number(option.dataset.max)||1);
quantity.value=Math.min(Number(quantity.value)||1,Number(quantity.max));
button.disabled=option.dataset.available!=='true';
button.textContent=button.disabled?button.dataset.sold:button.dataset.label;
const url=new URL(window.location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
});
});
}
initialiseClassProducts();
document.addEventListener('shopify:section:load',initialiseClassProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-photos"] && !Shopify.designMode) return;
  try {
    
(()=> {
const instances=new Map();
function init(root){
if(instances.has(root))return;
const viewport=root.querySelector('.nd-photo-window'),track=root.querySelector('.nd-photo-track'),button=root.querySelector('[data-nd-pause]');
const originals=[...track.children],motion=matchMedia('(prefers-reduced-motion: reduce)');
let stopped=false,hover=false,focused=false,visible=true,frame=0,last=0,position=0;
const editor=Boolean(window.Shopify&&Shopify.designMode);
const canMove=()=>root.dataset.autoplay==='true'&&!editor&&!motion.matches&&!stopped&&!hover&&!focused&&visible&&!document.hidden;
let clones=[];
if(originals.length>1&&!editor){clones=originals.map(el=>{const copy=el.cloneNode(true);copy.setAttribute('aria-hidden','true');copy.inert=true;[copy,...copy.querySelectorAll('*')].forEach(n=>{[...n.attributes].forEach(a=>{if(a.name.startsWith('data-shopify')||a.name==='id')n.removeAttribute(a.name)})});track.append(copy);return copy})}
function tick(time){if(!root.isConnected)return;
if(last&&canMove()&&clones.length){const distance=clones[0].offsetLeft-originals[0].offsetLeft;position+=Math.min(time-last,50)*.025;if(distance>0&&position>=distance)position-=distance;viewport.scrollLeft=position}
if(!canMove())position=viewport.scrollLeft;last=time;frame=requestAnimationFrame(tick)}
const onEnter=()=>{hover=true},onLeave=()=>{hover=false},onFocus=()=>{focused=true},onBlur=e=>{if(!root.contains(e.relatedTarget))focused=false};
const stop=()=>{stopped=true;button.textContent=button.dataset.playLabel};
const toggle=()=>{stopped=!stopped;button.textContent=stopped?button.dataset.playLabel:button.dataset.pauseLabel};
root.addEventListener('mouseenter',onEnter);root.addEventListener('mouseleave',onLeave);root.addEventListener('focusin',onFocus);root.addEventListener('focusout',onBlur);
viewport.addEventListener('pointerdown',stop);button.addEventListener('click',toggle);
const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting});observer.observe(root);
frame=requestAnimationFrame(tick);
instances.set(root,()=>{cancelAnimationFrame(frame);observer.disconnect();clones.forEach(el=>el.remove());root.removeEventListener('mouseenter',onEnter);root.removeEventListener('mouseleave',onLeave);root.removeEventListener('focusin',onFocus);root.removeEventListener('focusout',onBlur);viewport.removeEventListener('pointerdown',stop);button.removeEventListener('click',toggle);instances.delete(root)});
}
function scan(){document.querySelectorAll('[data-nd-carousel]').forEach(init)}
scan();document.addEventListener('shopify:section:load',scan);
document.addEventListener('shopify:section:unload',event=>{instances.forEach((destroy,root)=>{if(event.target.contains(root))destroy()})});
document.addEventListener('shopify:block:select',event=>{if(event.target.closest('[data-nd-carousel]'))event.target.scrollIntoView({behavior:'auto',block:'nearest',inline:'center'})});
})();

  } catch(e) { console.error(e); }
})();
})();
